import Vue from 'vue'
import wysiwyg from 'terencecz'
import 'terencecz/dist/vueWysiwyg.css'
import VueWorker from 'vue-worker'
import VueWordCloud from 'vuewordcloud'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import 'loaders.css/loaders.min.css'
import VueTimers from 'vue-timers'
import Router from 'vue-router'
import App from '@/App'
import { router } from '@/router'
import store from '@/store'
import MIcon from '@/components/MIcon'
import TreeView from 'vue-json-tree-view'
// import './plugins/axios'
import { directives } from './acl/directives'
import VueLocalStorage from 'vue-localstorage'

import { isIE } from './utils/browser'

if (isIE()) {
  alert('We\'re sorry but Expert doesn\'t work properly with IE. Please use Chrome instead.')
} else {
  Vue.use(VueWorker)
  Vue.use(TreeView)
  Vue.use(wysiwyg, {})
  Vue.use(VueTimers)
  Vue.use(Router)
  Vue.component(VueWordCloud.name, VueWordCloud)
  Vue.component('m-icon', MIcon)
  Vue.use(Antd)
  Vue.use(VueLocalStorage)

  Vue.config.productionTip = false
  directives.register()

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
